import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { Briefcase, ChartLineUp, Headset } from '@phosphor-icons/react';
import theme from '../../../theme';

const AuthPageRightSection: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#EFEEFD',
        gap: 2,
        borderRadius: '12px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '40px',
          }}
        >
          The Next-Gen
        </Typography>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            background:
              'linear-gradient(89.99deg, #5A4CE6 42.74%, #322A80 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Voice AI OS
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: '520px',
          width: '100%',
          textAlign: 'center',
          mb: 4,
        }}
      >
        {/* Feature Cards */}
        <Stack spacing={2}>
          {/* Card 1 */}
          <Paper
            elevation={0}
            sx={{
              width: 520,
              height: 100,
              p: 3,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              backgroundColor: '#FFFFFF',
              cursor: 'pointer',
              border: '1px solid #DCE0E7',
              boxShadow: '0px 0px 23px 0px #5A4CE640',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.primary.main,
                backgroundColor: '#F4F7FF',
                borderRadius: '100%',
                padding: '10px',
              }}
            >
              <Briefcase size={24} weight="duotone" />
            </Box>
            <Typography
              sx={{
                fontWeight: 500,
                color: '#2B2D3F',
                display: 'flex',
                alignItems: 'center',
                fontSize: '18px',
                whiteSpace: 'nowrap',
              }}
            >
              The Best Voice for Your{' '}
              <Typography
                component="span"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 500,
                  mx: 0.5,
                  fontSize: '18px',
                }}
              >
                Business
              </Typography>
            </Typography>
          </Paper>

          {/* Card 2 */}
          <Paper
            elevation={0}
            sx={{
              width: 520,
              height: 100,
              p: 3,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 2,
              backgroundColor: '#FFFFFF',
              cursor: 'pointer',
              border: '1px solid #DCE0E7',
              boxShadow: '0px 0px 23px 0px #5A4CE640',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                color: '#2B2D3F',
                display: 'flex',
                alignItems: 'center',
                fontSize: '18px',
                whiteSpace: 'nowrap',
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 500,
                  mr: 0.5,
                  fontSize: '18px',
                }}
              >
                Intelligent Conversation
              </Typography>{' '}
              Management & Insights
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.primary.main,
                backgroundColor: '#F4F7FF',
                borderRadius: '100%',
                padding: '10px',
              }}
            >
              <ChartLineUp size={24} weight="duotone" />
            </Box>
          </Paper>

          {/* Card 3 */}
          <Paper
            elevation={0}
            sx={{
              width: 520,
              height: 100,
              p: 3,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              backgroundColor: '#FFFFFF',
              cursor: 'pointer',
              border: '1px solid #DCE0E7',
              boxShadow: '0px 0px 23px 0px #5A4CE640',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.primary.main,
                backgroundColor: '#F4F7FF',
                borderRadius: '100%',
                padding: '10px',
              }}
            >
              <Headset size={24} weight="duotone" />
            </Box>
            <Typography
              sx={{
                fontWeight: 500,
                color: '#2B2D3F',
                display: 'flex',
                alignItems: 'center',
                fontSize: '18px',
                whiteSpace: 'nowrap',
              }}
            >
              Voice AI for{' '}
              <Typography
                component="span"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 500,
                  mx: 0.5,
                  fontSize: '18px',
                }}
              >
                Customer Support & FAQs
              </Typography>
            </Typography>
          </Paper>
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthPageRightSection;
